import styled from '@emotion/styled';
import { LeadProgram } from '../../constants';

export const Bullet = styled.div<{ program: LeadProgram }>`
  display: flex;
  min-width: 40px;
  min-height: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  background: ${({ program }) =>
    program === LeadProgram.NP ? 'rgba(233, 212, 242, 0.6)' : '#d3f0f0'};
`;
